import { render, staticRenderFns } from "./atm.vue?vue&type=template&id=5fb4f037&scoped=true"
import script from "./atm.vue?vue&type=script&lang=js"
export * from "./atm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb4f037",
  null
  
)

export default component.exports